import { atom } from "recoil";
import { IContact } from "../types/Contact";

export const ContactsAtom = atom<IContact[]>({
  key: "Contacts",
  default: [],
});

export const ContactsTotalAtom = atom<number>({
  key: "ContactsTotal",
  default: 0,
});

export const FilteredContactsAtom = atom<IContact[]>({
  key: "FilteredContacts",
  default: [],
});
